import { render, staticRenderFns } from "./ClientSpendContainer.vue?vue&type=template&id=722fbdbb&"
import script from "./ClientSpendContainer.vue?vue&type=script&lang=js&"
export * from "./ClientSpendContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports